module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "layoutTop"
  }), _vm._v(" "), _c('page-nav-bar', {
    attrs: {
      "popoverName": "",
      "subNavTitle": _vm.ServiceDetails,
      "ReturnButton": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 offset-md-1"
  }, [_c('div', {
    staticClass: "panel21 panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "content-block labelAccordionForm"
  }, [(_vm.details.direction === '0') ? _c('div', [_c('img', {
    staticClass: "formIcon",
    attrs: {
      "src": require("../../../assets/static/images/icons/inbox_into.png")
    }
  }), _vm._v("\n                    " + _vm._s(_vm.$t('received.rcvd_verb_past', {
    itemname: _vm.$t(this.$engine.services.getSingularNameFromServiceId(this.$engine.user.currentService.id))
  })) + "\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.details.direction === '1') ? _c('div', [_c('img', {
    staticClass: "formIcon",
    attrs: {
      "src": require("../../../assets/static/images/icons/inbox_out.png")
    }
  }), _vm._v("\n                    " + _vm._s(_vm.$t('sent.snt_verb_past', {
    itemname: _vm.$t(this.$engine.services.getSingularNameFromServiceId(this.$engine.user.currentService.id))
  })) + "\n                  ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-item accordion-item-expanded accordionForm"
  }, [_c('a', {
    staticClass: "item-content item-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.rotateChevron($event)
      }
    }
  }, [_c('div', {
    staticClass: "item-inner",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "form-group row justify-content-start"
  }, [_c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto text-uppercase"
  }, [_vm._v("\n                              " + _vm._s(_vm.ServiceDetails) + "\n                              "), _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-item-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.rsn'),
      "inputValue": _vm.details.remittanceInformation
    }
  }), _vm._v(" "), _c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.idtfr'),
      "inputValue": _vm.details.endToEndId
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.rqst_date'),
      "inputValue": _vm._f("formatDate")(_vm.details.creationDate)
    }
  }), _vm._v(" "), _c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.status.status_label'),
      "inputValue": _vm.getStatusLabel(_vm.details.status, _vm.details.negotStatus),
      "statusIcon": _vm.getStatusIcon(_vm.details.status, _vm.details.negotStatus)
    }
  }, [(_vm.details.status === '5') ? _c('f7-button', {
    staticClass: "blueBackground pain001ViewerButton",
    on: {
      "click": function($event) {
        return _vm.viewXML('pain001', _vm.details.id)
      }
    }
  }, [_vm._v("\n                          View Transfer Order File\n                        ")]) : _vm._e()], 1)], 1), _vm._v(" "), ((_vm.details.status === '0' && _vm.details.negotStatus === '0') || _vm.details.status === '7' || _vm.details.status === '8') ? _c('div', {
    staticClass: "row"
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.amnt'),
      "inputValue": _vm.details.amount + ' ' + _vm.getCurrencyIcon(_vm.details.currency)
    }
  }), _vm._v(" "), _c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.exec_date'),
      "inputValue": _vm._f("formatDate")(_vm.details.requestedExecutionDate)
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.details.status === '0' && _vm.details.negotStatus === '10') ||
    (_vm.details.status === '0' && _vm.details.negotStatus === '11') ||
    _vm.details.status === '1' ||
    _vm.details.status === '2' ||
    _vm.details.status === '3' ||
    _vm.details.status === '4' ||
    _vm.details.status === '5') ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.orig_amount'),
      "inputValue": _vm.details.amount + ' ' + _vm.getCurrencyIcon(_vm.details.currency)
    }
  }), _vm._v(" "), _c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.exec_date_orig'),
      "inputValue": _vm._f("formatDate")(_vm.details.requestedExecutionDate)
    }
  })], 1)]) : _vm._e(), _vm._v(" "), ((_vm.details.status === '0' && _vm.details.negotStatus === '10') ||
    (_vm.details.status === '0' && _vm.details.negotStatus === '11')) ? _c('div', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.new_amount'),
      "inputValue": _vm.details.pmtNegot.amountDebtor + ' ' + _vm.getCurrencyIcon(_vm.details.ccy)
    }
  }), _vm._v(" "), (_vm.details.pmtNegot.multiPayments.length > 0) ? _c('div', {
    staticClass: "form-group col-sm-6"
  }, [_c('label', {
    staticClass: "createInvoiceBand"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('common.pymnts_annoucement', {
    install_number: _vm.details.pmtNegot.multiPayments.length
  })) + "\n                              ")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-bordered table-installment"
  }, [_c('thead', {
    staticClass: "thead-dark"
  }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('common.installment_amount')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('common.installment_date')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.details.pmtNegot.multiPayments), function(pmt, index) {
    return _c('tr', {
      key: 'pmt-' + index
    }, [_c('td', [_vm._v(_vm._s(pmt.amount + ' ' + _vm.getCurrencyIcon(_vm.details.currency)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(pmt.date)))])])
  }), 0)])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), ((_vm.details.negotStatus === '12')) ? _c('div', [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.final_amount'),
      "inputValue": _vm.details.pmtResp.dbtAmt !== '' ? (_vm.details.pmtResp.dbtAmt + _vm.getCurrencyIcon(_vm.details.currency)) : (_vm.details.amount + _vm.getCurrencyIcon(_vm.details.currency))
    }
  }), _vm._v(" "), (_vm.details.pmtResp.multPmts.length > 0) ? _c('div', {
    staticClass: "form-group col-sm-6"
  }, [_c('label', {
    staticClass: "createInvoiceBand"
  }, [_vm._v("\n                                  " + _vm._s(_vm.$t('common.pymnts_annoucement', {
    install_number: _vm.details.pmtResp.multPmts.length
  })) + "\n                                ")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-bordered table-installment"
  }, [_c('thead', {
    staticClass: "thead-dark"
  }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('common.installment_amount')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('common.installment_date')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.details.pmtResp.multPmts), function(pmt, index) {
    return _c('tr', {
      key: 'pmt-' + index
    }, [_c('td', [_vm._v(_vm._s(pmt.amount + ' ' + _vm.getCurrencyIcon(_vm.details.currency)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(pmt.date)))])])
  }), 0)])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.details.attachmentId !== '') ? _c('div', {
    staticClass: "form-group row",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [(!_vm.ifAndroid) ? _c('button', {
    staticClass: "button-action firstButtonMarginTop",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.view(_vm.details.attachmentId)
      }
    }
  }, [_c('i', {
    staticClass: "icon fa fa-paperclip"
  }), _vm._v("\n                            View Attachment\n                          ")]) : _vm._e(), _vm._v(" "), (_vm.ifAndroid) ? _c('button', {
    staticClass: "button-action firstButtonMarginTop",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.view(_vm.details.attachmentId)
      }
    }
  }, [_c('i', {
    staticClass: "icon fa fa-paperclip"
  }), _vm._v("\n                              Download Attachment\n                          ")]) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "accordion-item accordionForm"
  }, [_c('a', {
    staticClass: "item-content item-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.rotateChevron($event)
      }
    }
  }, [_c('div', {
    staticClass: "item-inner",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "form-group row justify-content-start"
  }, [(_vm.details.direction === '0') ? _c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto"
  }, [_vm._v("\n                                    SENDER INFORMATION\n                                    "), _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")])]) : _vm._e(), _vm._v(" "), (_vm.details.direction === '1') ? _c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto"
  }, [_vm._v("\n                                    MY ACCOUNT INFORMATION\n                                    "), _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-item-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.nme'),
      "inputValue": _vm.details.creditorName
    }
  }), _vm._v(" "), _c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.idtfr'),
      "inputValue": _vm.details.creditorIdentifier
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('bank_accounts.bank_account_singular'),
      "inputValue": _vm.hideIban(_vm.details.creditorBankAccount)
    }
  })], 1)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "accordion-item accordionForm"
  }, [_c('a', {
    staticClass: "item-content item-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.rotateChevron($event)
      }
    }
  }, [_c('div', {
    staticClass: "item-inner",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "form-group row justify-content-start"
  }, [(_vm.details.direction === '0') ? _c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto"
  }, [_vm._v("\n                                      MY ACCOUNT INFORMATION\n                                      "), _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")])]) : _vm._e(), _vm._v(" "), (_vm.details.direction === '1') ? _c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto"
  }, [_vm._v("\n                                      SENDER INFORMATION\n                                      "), _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-item-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.nme'),
      "inputValue": _vm.details.debtorName
    }
  }), _vm._v(" "), _c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.idtfr'),
      "inputValue": _vm.details.debtorIdentifier
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-start"
  }, [_c('div', {
    staticClass: "form-group col-sm-6"
  }, [_c('label', {
    staticClass: "createInvoiceBandlabelAccordionForm"
  }, [_vm._v("\n                                    Bank account\n                                  ")]), _vm._v(" "), ((_vm.details.direction === '1' && _vm.paymentMethod === 'application') ||
    (_vm.details.direction === '0' &&
      (_vm.details.status === '4' || _vm.details.status === '1'))) ? _c('div', {
    staticClass: "labelAccordionForm"
  }, [(_vm.details.debtorBankAccount.length > 0) ? _c('input', {
    staticClass: "form-control inputAccordionForm",
    attrs: {
      "type": "text",
      "disabled": "true"
    },
    domProps: {
      "value": _vm.hideIban(_vm.details.debtorBankAccount)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.details.debtorBankAccount.length === 0) ? _c('span', [_vm._v("Not specified")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.details.direction === '0' && _vm.details.status === '0' && _vm.paymentMethod === 'application') ? _c('div', {
    staticClass: "labelAccordionForm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankAccountSelectDebit),
      expression: "bankAccountSelectDebit"
    }],
    staticClass: "form-control inputAccordionForm",
    class: {
      redBackground: _vm.bankAccountSelectDebit === ''
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.bankAccountSelectDebit)
    },
    on: {
      "focus": function($event) {
        return _vm.showBankAccountSelectionList($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bankAccountSelectDebit = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.showIbanBox) ? _c('div', {
    ref: "ibanBox",
    staticClass: "col-12 bankAccountDebitSelectionListContainer"
  }, [_c('div', {
    staticClass: "closeSelectionListContainerLabel",
    on: {
      "click": _vm.closeSelectionListContainer
    }
  }, [_c('div', {
    staticClass: "closeSelectionListContainerLabelName"
  }, [_vm._v("\n                                          Bank account list\n                                        ")]), _vm._v(" "), _c('f7-button', {
    staticClass: "button-round orangeBackground rightButton",
    staticStyle: {
      "padding": "0px 3px"
    }
  }, [_vm._v("\n                                          Close\n                                        ")])], 1), _vm._v(" "), _c('ul', {
    staticClass: "bankAccountDebitSelectionList"
  }, _vm._l((_vm.bankAccounts), function(bankAccount) {
    return (_vm.bankAccounts.length > 0) ? _c('li', {
      staticClass: "bankAccountDebitSelectionListItem",
      attrs: {
        "data-iban": bankAccount.iban
      },
      on: {
        "click": function($event) {
          return _vm.selectBankAccount($event)
        }
      }
    }, [_c('div', [_vm._v(_vm._s(bankAccount.iban))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(bankAccount.name))])]) : _c('li', {
      staticClass: "bankAccountDebitSelectionListItem"
    }, [_c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v("No bank account")])])
  }), 0)]) : _vm._e()]) : _vm._e()])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "accordion-item accordionForm"
  }, [_c('a', {
    staticClass: "item-content item-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.rotateChevron($event)
      }
    }
  }, [_c('div', {
    staticClass: "item-inner",
    class: _vm.colorBottomButton
  }, [_vm._m(3)])]), _vm._v(" "), (_vm.details.history.length > 0) ? _c('div', {
    staticClass: "accordion-item-content"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-status-history"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.details.history), function(record) {
    return _c('tr', {
      key: record.id,
      staticClass: "transactionDetailFontSize"
    }, [_c('td', {
      staticClass: "dateTimehistoryHeight"
    }, [_vm._v(_vm._s(_vm._f("formatDateTime")(record.creationDate)))]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.getHistoryLabel(record.status)) + " "), _c('i', {
      class: 'icon icon-transaction-detail ' + _vm.getHistoryIcon(record.status)
    })]), _vm._v(" "), ((record.status === '10' || record.status === '11') && record.comment !== '') ? _c('div', {
      staticClass: "item-content"
    }, [_c('div', {
      staticClass: "item-inner",
      staticStyle: {
        "display": "block"
      }
    }, [_c('div', {
      staticClass: "item-title-row",
      staticStyle: {
        "font-style": "italic"
      }
    }, [_vm._v("\n                                          Negotiation Comment:\n                                        ")]), _vm._v(" "), _c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticStyle: {
        "color": "#8e8e93"
      }
    }, [_vm._v(_vm._s(record.comment))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "transactionDetailFontSize"
    }, [((_vm.details.status === '1' || _vm.details.status === '2' || _vm.details.status === '3') && _vm.details.responseComment !== '') ? _c('li', {
      staticClass: "item-content"
    }, [_c('div', {
      staticClass: "item-inner",
      staticStyle: {
        "display": "block"
      }
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_vm._v("\n                                            Response Comment:\n                                          ")]), _vm._v(" "), _c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticStyle: {
        "color": "#8e8e93"
      }
    }, [_vm._v(_vm._s(_vm.details.responseComment))])])])]) : _vm._e()])])])
  }), 0)])])])]) : _vm._e()])])])]), _vm._v(" "), (_vm.details.direction === '0' && _vm.details.status === '0') ? _c('div', {
    staticClass: "inboxDetailButton",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "row justify-content-start"
  }, [_c('div', {
    staticClass: "col-md-3 offset-md-1"
  }, [((_vm.details.pymtModAcpt === 'true' && _vm.details.negotStatus !== '11' && _vm.details.negotStatus !== '10' && _vm.paymentMethod === 'bankCard') ||
    (_vm.details.pymtModAcpt === 'false' && _vm.paymentMethod === 'bankCard')) ? _c('button', {
    staticClass: "button-action firstButtonMarginTop",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.bankCardAccept($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon fa fa-check"
  }), _vm._v("\n\t\t\t\t\tAccept\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), ((_vm.details.pymtModAcpt === 'true' && _vm.details.negotStatus !== '11' && _vm.details.negotStatus !== '10' && _vm.paymentMethod === 'application') ||
    (_vm.details.pymtModAcpt === 'false' && _vm.paymentMethod === 'application')) ? _c('button', {
    staticClass: "button-action firstButtonMarginTop",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.transactionAccepted()
      }
    }
  }, [_c('i', {
    staticClass: "icon fa fa-check"
  }), _vm._v("\n\t\t\t\t\tAccept\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.details.pymtModAcpt === 'true' && _vm.details.negotStatus === '11') ? _c('button', {
    staticClass: "button-action firstButtonMarginTop",
    attrs: {
      "round": ""
    },
    on: {
      "click": _vm.confirmNegotiation
    }
  }, [_c('i', {
    staticClass: "icon fa fa-check"
  }), _vm._v("\n          Accept\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    attrs: {
      "href": "/payments/negotiate/"
    }
  }, [(_vm.details.pymtModAcpt === 'true' && _vm.details.negotStatus === '0') ? _c('button', {
    staticClass: "button-action firstButtonMarginTop",
    attrs: {
      "round": ""
    }
  }, [_c('i', {
    staticClass: "icon fa fa-repeat"
  }), _vm._v("\n            Send Negotiation Request\n          ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [(_vm.details.negotStatus !== '10') ? _c('button', {
    staticClass: "button-action firstButtonMarginTop",
    attrs: {
      "round": ""
    },
    on: {
      "click": _vm.transactionRefused
    }
  }, [_c('i', {
    staticClass: "icon fa fa-hand-stop-o"
  }), _vm._v("\n          Refuse\n        ")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.details.direction === '1') ? _c('div', {
    class: _vm.colorBottomButton
  }, [(_vm.details.status === '0' && _vm.details.negotStatus === '10' && _vm.details.pymtModAcpt === 'true') ? _c('div', {
    staticClass: "row justify-content-start"
  }, [_c('div', {
    staticClass: "col-md-3 offset-md-1"
  }, [_c('button', {
    staticClass: "button-action firstButtonMarginTop",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.acceptNegotiation()
      }
    }
  }, [_c('i', {
    staticClass: "icon fa fa-handshake-o"
  }), _vm._v("\n          Accept Negotiation\n        ")])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "button-action firstButtonMarginTop",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.refuseNegotiation()
      }
    }
  }, [_c('i', {
    staticClass: "icon fa fa-hand-stop-o"
  }), _vm._v("\n          Refuse and insist on the original request\n        ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-start"
  }, [_c('div', {
    staticClass: "col-md-3 offset-md-8"
  }, [((_vm.details.status === '0' && _vm.details.negotStatus === '11') ||
    (_vm.details.status === '0' && _vm.details.negotStatus === '0')) ? _c('button', {
    staticClass: "button-action firstButtonMarginTop",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.remindReceiver(_vm.details.id)
      }
    }
  }, [_c('i', {
    staticClass: "icon fa fa-bell"
  }), _vm._v("\n          Remind receiver\n        ")]) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "layoutBottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "toolbarPageBottomBlank"
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "transactionDetailFontSize form-group row"
  }, [_c('div', {
    staticClass: "transactionDetailSubHeader col-12"
  }, [_vm._v("\n                            Original terms\n                          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "transactionDetailFontSize form-group row"
  }, [_c('div', {
    staticClass: "transactionDetailSubHeader col-12"
  }, [_vm._v("\n                              Negotiation\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "transactionDetailFontSize form-group row"
  }, [_c('div', {
    staticClass: "transactionDetailSubHeader col-12"
  }, [_vm._v("\n                                Final Terms\n                              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row justify-content-start"
  }, [_c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto"
  }, [_vm._v("\n                                  REQUEST TO PAY HISTORY\n                                  "), _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-dark"
  }, [_c('tr', [_c('th', {
    staticClass: "reponsiveColumnWidth",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Date")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Status")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    attrs: {
      "href": "/payments/negotiate/"
    }
  }, [_c('button', {
    staticClass: "button-action firstButtonMarginTop",
    attrs: {
      "round": ""
    }
  }, [_c('i', {
    staticClass: "icon fa fa-repeat"
  }), _vm._v("\n            Negotiate\n          ")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-068722bc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-068722bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/detailPages/RequestToPayDetailPage.vue
// module id = 1614
// module chunks = 2